<template>
  <button :class="classes" v-if="to === ''">
    <slot></slot>
  </button>

  <router-link :class="classes" v-else :to="to">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  name: 'VButton',
  props: {
    to: {
      type: String,
      default: ''
    },
    block: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    }
  },
  computed: {
    classes () {
      let classes = 'btn'

      if (this.color) {
        classes += ` btn--${this.color}`
      }

      if (this.size) {
        classes += ` btn--${this.size}`
      }

      if (this.block) {
        classes += ' btn--block'
      }

      if (this.disabled) {
        classes += ' btn--disabled'
      }

      return classes
    }
  }
}
</script>

<style lang="stylus" scoped>
  .btn
    border none
    box-shadow none
    padding 2.5px 15px
    font-size 14px
    text-transform uppercase
    font-weight 700
    background #423799
    color #fff
    border-radius 5px
    cursor pointer
    text-decoration none
    text-align center

    &--block
      display block
      width 100%
      max-width 100%

    &--disabled
      pointer-events none
      opacity 0.85

    &--small 
      height: 29px;
      padding: 0px 10px 7px;
      font-size 11px
      width: 100px;

    &--danger
      background #ff1744
      color #fff

</style>



// WEBPACK FOOTER //
// VButton.vue?51411010